import React, { useState } from 'react'
 

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'


import { postEmpolymentTypes } from '../../../../MyApi/hr/empolyment'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddEmpolymentType from '../../../../Components/hr/employmenttypes/employmentTypesStore/AddEmpolymentType'



const EmpolyMentTypesStore = () => {
const [name ,setName]= useState("")
const [companyId ,setCompanyId]= useState("")
const [description, setDescription] = useState("")
const [active ,setActive] = useState(1)
const [selectedOption, setSelectedOption] = useState('');

 const mutation = useMutation("postLevels" , (postData)=>postEmpolymentTypes(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setCompanyId("")
        setSelectedOption("")
        setName("")
        setDescription("")

    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name,   
        description,
        active,
        sb_company_id:companyId,
    })
 }
 const isDisabled = () => {
   return !(name && companyId && description ) 
 
   
}
  return ( 

    <div>
        <PageHeader title="Add Employment Type"  showBack={true}  saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddEmpolymentType setName={setName} setSelectedOption={setSelectedOption} selectedOption={selectedOption} companyId={companyId} setCompanyId={setCompanyId} name={name} setDescription={setDescription} description={description} setActive={setActive} active={active} />
    </div>
  )
}

export default EmpolyMentTypesStore